'use client';

import { useCallback, useRef, useState } from 'react';

import { AddressForm, type AddressFormRef } from '@/components/AddressForm';
import { motion } from '@/libs';

import { Button, Icon } from '../../ui';

type UserAddressFormProps = {
  onAddressComplete: () => void;
  onBack: () => void;
};

export const UserAddressForm = ({ onAddressComplete, onBack }: UserAddressFormProps) => {
  const addressFormRef = useRef<AddressFormRef>(null);
  const [isValid, setIsValid] = useState(false);

  const handleSubmit = useCallback(() => {
    addressFormRef.current?.submit();
  }, []);

  return (
    <motion.div
      data-cy="user-address-form"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="flex flex-col gap-4"
    >
      <p className="text-sm text-foreground text-center">
        Informe seu endereço para concluir o cadastro.
      </p>

      <div className="flex flex-col mx-auto w-full md:max-w-[336px]">
        <div
          data-cy="user-address-form-fields"
          className="flex flex-col gap-y-4 max-h-[55vh] overflow-y-auto overscroll-contain px-1.5 -mx-1.5 pb-2"
        >
          <AddressForm
            ref={addressFormRef}
            handleNextStep={onAddressComplete}
            onValidationChange={setIsValid}
          />
        </div>

        <div className="flex flex-col gap-2 pt-4">
          <Button
            data-cy="user-address-form-submit-button"
            type="button"
            onClick={handleSubmit}
            disabled={!isValid}
            variant="primary"
            size="large"
            className="h-12 w-full flex items-center text-background text-base uppercase"
          >
            <span className="mx-auto">Concluir Cadastro</span>
            <Icon.ChevronRight width={24} height={24} />
          </Button>

          <Button type="button" variant="ghost" className="mx-auto" onClick={onBack}>
            Voltar
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
